import { render, staticRenderFns } from "./MusicControl-v3.vue?vue&type=template&id=edd5050a&scoped=true"
import script from "./MusicControl-v3.vue?vue&type=script&lang=js"
export * from "./MusicControl-v3.vue?vue&type=script&lang=js"
import style0 from "./MusicControl-v3.vue?vue&type=style&index=0&id=edd5050a&prod&lang=less"
import style1 from "./MusicControl-v3.vue?vue&type=style&index=1&id=edd5050a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd5050a",
  null
  
)

export default component.exports